import { useRoomCreateRoomTask, useRoomDeleteRoomTask } from "@crowdcoursing/api/openapi";

import { useToast } from "./useToast";

export const useRoomTaskManagement = (roomId: string, userId: string, onSuccess?: () => void) => {
  const toast = useToast();

  const { mutateAsync: createTaskMutation, isPending: isCreating } = useRoomCreateRoomTask({
    onSuccess: () => {
      toast.success("Task created successfully!");
      onSuccess?.();
    },
  });

  const { mutateAsync: deleteTaskMutation, isPending: isDeleting } = useRoomDeleteRoomTask({
    onSuccess: () => {
      toast.success("Task deleted successfully!");
      onSuccess?.();
    },
  });

  const createTask = async (task: { name: string; description: string; dueDate: Date }) => {
    await createTaskMutation(
      {
        body: {
          description: task.description,
          dueDate: task.dueDate.toISOString(),
          name: task.name,
          roomId,
          userId,
        },
        pathParams: {
          roomId,
        },
      },
      {
        onError: (error) => {
          console.error("Error creating task:", error);
          toast.error("Failed to create task. Please try again.");
        },
      },
    );
  };

  const deleteTask = async (task: { id: string }) => {
    await deleteTaskMutation(
      {
        pathParams: {
          roomId,
          taskId: task.id,
        },
      },
      {
        onError: (error) => {
          console.error("Error deleting task:", error);
          toast.error("Failed to delete task. Please try again.");
        },
      },
    );
  };

  return {
    completeTask: deleteTask,
    createTask,
    deleteTask,
    isCreating,
    isDeleting,
    isLoading: isCreating || isDeleting,
  };
};
